(function($) {
	$('.contained-image__replay').click(function(event) {
		imageEl = $(this).parent().find('img');
		// Add ?a to image src to clear cache/enable replay in edge/IE
		src = imageEl.attr('src')+"?a";
		imageEl.attr('src', src );
	});
}(jQuery));
